export const SdkSVG = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_66_2847)">
      <path
        d="M9.99998 11.6667L8.33331 10L9.99998 8.33334L11.6666 10L9.99998 11.6667ZM8.22915 6.77084L6.14581 4.68751L9.99998 0.833344L13.8541 4.68751L11.7708 6.77084L9.99998 5.00001L8.22915 6.77084ZM4.68748 13.8542L0.833313 10L4.68748 6.14584L6.77081 8.22918L4.99998 10L6.77081 11.7708L4.68748 13.8542ZM15.3125 13.8542L13.2291 11.7708L15 10L13.2291 8.22918L15.3125 6.14584L19.1666 10L15.3125 13.8542ZM9.99998 19.1667L6.14581 15.3125L8.22915 13.2292L9.99998 15L11.7708 13.2292L13.8541 15.3125L9.99998 19.1667Z"
        fill="#D7D8E2"
      />
    </g>
    <defs>
      <clipPath id="clip0_66_2847">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SdkSVG;
